import moment from 'moment';

/**
 * @description Cria labels do gráfico
 * @param {Date} dataInicial
 * @param {Date} dataFinal
 * @param {Date} dtInicialVerMais
 * @param {Date} dtFinalVerMais
 * @param {Boolean} verMais
 * @param {String} tipo
 */
export function createLabels(
  dataInicial,
  dataFinal,
  dtInicialVerMais,
  dtFinalVerMais,
  verMais,
  tipo
) {
  let dtInicial;
  let dtFinal;
  if (verMais || !dataInicial || !dataFinal) {
    dtInicial = moment(dtInicialVerMais);
    dtFinal = moment(dtFinalVerMais);
  } else {
    dtInicial = moment(dataInicial);
    dtFinal = moment(dataFinal);
  }

  const labels = [];
  if (tipo === 'DAILY') {
    dtInicial = dtInicial.startOf('days');
    dtFinal = dtFinal.endOf('days');
    for (
      let dtIni = dtInicial;
      dtIni.isBefore(dtFinal, 'minute');
      dtIni.add(1, 'days')
    ) {
      labels.push(dtIni.format('D/M'));
    }
  }

  if (tipo === 'WEEKLY') {
    dtInicial = dtInicial.startOf('isoWeeks');
    dtFinal = dtFinal.endOf('isoWeeks');
    for (
      let dtIni = dtInicial;
      dtIni.isBefore(dtFinal, 'minute');
      dtIni.add(1, 'isoWeeks')
    ) {
      labels.push(`sem ${dtIni.format('W')}`);
    }
  }

  if (tipo === 'MONTHLY') {
    dtInicial = dtInicial.startOf('month');
    dtFinal = dtFinal.endOf('month');
    for (
      let dtIni = dtInicial;
      dtIni.isBefore(dtFinal, 'minute');
      dtIni.add(1, 'month')
    ) {
      labels.push(dtIni.format('MMM').toLowerCase());
    }
  }

  return labels;
}
